import { render, staticRenderFns } from "./DetailSubPage.vue?vue&type=template&id=6ccfbb4f&scoped=true&"
import script from "./DetailSubPage.vue?vue&type=script&lang=ts&"
export * from "./DetailSubPage.vue?vue&type=script&lang=ts&"
import style0 from "./DetailSubPage.vue?vue&type=style&index=0&id=6ccfbb4f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ccfbb4f",
  null
  
)

export default component.exports